import React from 'react'
import { captureLanding } from './lib/landing'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import { ToastProvider } from './components/Toast'
import './styles/index.css'
// Replays a PRIOR decision only — never grants anything. A visitor who has not
// chosen loads no tags at all; the banner in App handles first contact.
import { initConsent } from './utils/consent'

initConsent()

// BEFORE React mounts. document.referrer only describes the initial page load,
// and any client-side navigation afterwards makes it unrecoverable. Capturing
// here means it is banked no matter which route the visitor landed on.
captureLanding()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
